import { integrationIdFormat } from "@redotech/redo-integration-id";
import { HttpSecret } from "@redotech/redo-integrations-configs/connections/http.connection-type";
import * as z from "zod";
import { ConnectionView } from "./connection";

/** The server validates `secret` against the stored connection's auth scheme. */
export const rotateConnectionSecret = {
  name: "rotateConnectionSecret" as const,
  input: z.object({ id: integrationIdFormat.schema, secret: HttpSecret }),
  output: ConnectionView,
};
